import BaseApi from "../base/BaseApi";

class BackofficeApi extends BaseApi {
    private _isDev: boolean
    private _isPopina: boolean

    constructor(isDev: boolean = false, isPopina: boolean = true) {
        super(isDev
            ? (isPopina) ? "dev.backoffice.popina.com/api" : "dev.backoffice.jalia.fr/api"
            : (isPopina) ? "backoffice.popina.com/api" : "backoffice.jalia.fr/api",
            true
        );
        this._isDev = isDev;
        this._isPopina = isPopina;
    }

    private get header(): any {
        return { 'Content-Type': 'application/json' }
    }

    public get isDev(): boolean {
        return this._isDev;
    }

    connectWithEmailAndPassword(email: string, password: string) {
        const body = { 'email': email, 'password': password };
        return this.postRequest('/account/login', this.header, body).then((response) => {
            console.log(response);
            return response;
        }).catch((err) => {
            console.log(err);
            return err;
        })
    }

    fetchAccountWithUid(uid: string) {
        return this.getRequest('/account/' + uid, this.header);
    }

    fetchPopinaCarteWithEstablishment(token: string) {
        const header = {
            'Content-Type': 'application/json',
            'popina_token': token,
            'webservice_locale': 'fr',
            'webservice_version': '3'
        };
        return this.getRequest('/establishment', header);
    }
}

export default BackofficeApi;